<template>
  <div
    class="goal-detail">
    <ul
      v-if="activity"
      class="list-unstyled">
      <li
        class="goal-detail__item mb-3">
        <div
          class="d-flex justify-content-between align-items-center p-2" 
          style="cursor: pointer;">
          <img
            v-if="activity.file"
            src="@/assets/images/file-icon.svg"
            class="goal-detail__file-icon">
          <h3 :class="activityItemClass">
            <TemplateColorChip :color="activity.templateColor" />{{ activity.name }}
          </h3>
          <div class="goal-detail__box">
            <div class="goal-detail__count">
              +{{ activity.resultCount }}
            </div>
            <div class="goal-detail__date">
              {{ activity.workAt | prettyDate }}
            </div>
          </div>
        </div>

        <div
          class="goal-detail__body"
          @click="onClickActivityBody">
          <div class="goal-detail__record record p-2">
            <div class="d-flex justify-content-between">
              <h4 class="record__heading mb-4">
                活動記録<span class="record__date ml-2">{{ activity.updatedAt | prettyDateTime }}</span>
              </h4>
            </div>
            <div class="record__text">
              <p>{{ activity.detail }}</p>
            </div>
          </div>
        </div>

        <div
          v-if="isShowConditionPanel"
          class="condition-panel-wrapper mx-2 pt-3"
          @click="onClickActivityBody">
          <ConditionPanel
            :activity="activity"
            is-show-all-body-pain-items>
            <template
              v-if="hasCondition"
              #header>
              <h4 class="condition-panel__heading mb-2">
                コンディション
              </h4>
            </template>
          </ConditionPanel>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import ConditionPanel from '@/components/parts/ConditionPanel.vue'
import TemplateColorChip from '@/components/parts/TemplateColorChip.vue'
export default {
  components: {
    ConditionPanel,
    TemplateColorChip
  },
  props: {
    activity: {
      type: Object,
      required: true
    }
  },
  computed: {
    activityItemClass() {
      if (this.activity.star) {
        return 'goal-detail__heading--marked'
      }
      return 'goal-detail__heading'
    },
    hasCondition() {
      return this.activity.conditionSetting !== null && this.activity.condition !== null
    },
    hasBodyPain() {
      return this.activity.bodyPainSetting?.isRecordBodyPain && this.activity.bodyPain !== null
    },
    isShowConditionPanel() {
      return this.hasCondition || this.hasBodyPain
    }
  },
  methods: {
    onClickActivityBody() {
      this.$emit('click-active')
    }
  }
}
</script>

<style lang="scss" scoped>
.goal-detail{
  position: relative;

  &__edit{
    color: $grey01;
    text-decoration: none;
    display: block;
    text-align: right;
    font-weight: bold;
    @media screen and (max-width:320px) {
      font-size: $fs-m;
    }
  }
  &__icon{
    display: inline-block;
    vertical-align: middle;
  }
  &__item{
    border: solid 1px $grey10;
    border-radius: 6px;
  }
  &__file-icon {
    position: absolute;
    top: -10px;
    right: -8px;
  }

  &__heading,
  &__heading--marked{
    font-size: $fs-nm;
    font-weight: bold;
    position: relative;
    padding-left: 16px;
    @media screen and (max-width:320px) {
      font-size: $fs-m;
    }
    &:before{
      content: "";
      position: absolute;
      background: $grey16;
      top: 4px;
      left: 0;
      height: 12px;
      width: 12px;
      border-radius: 50%;
    }
  }
  &__heading--marked:before{
    background: $pink;
  }
  &__box{
    text-align: right;
  }
  &__count{
    font-size: $fs-m;
    color: $l-blue;
    font-weight: bold;
  }
  &__date{
    font-size: $fs-s;
  }
  &__body{
    border-top: solid 1px $grey10;
  }
}

.record{
  &__heading{
    font-size: $fs-nm;
    font-weight: bold;
    @media screen and (max-width:320px) {
      font-size: $fs-m;
    }
  }
  &__date{
    color: $grey09;
    font-size: $fs-m;
    @media screen and (max-width:320px) {
      font-size: $fs-s;
    }
  }
  &__edit{
    position: relative;
  }
  &__edit-btn{
    box-shadow: 1px 2px 6px $grey05;
  }
  &__edit-icon{
    position: absolute;
    left: 0;
    top: 0;
    line-height: 34px;
    width: 34px;
  }
  &__text{
    color: $grey17;
    white-space:pre-wrap;
    word-wrap:break-word; 
    @media screen and (max-width:320px) {
      font-size: $fs-m;
    }
  }
}

.condition-panel-wrapper {
  border-top: solid 1px $grey10;
  .condition-panel__heading {
    font-size: $fs-m;
    font-weight: bold;
  }
}
</style>